import { AppConfig } from '../types';
import { getConfig, presets } from './presets';

// Get mode from environment variable or URL parameter
const getAppMode = (): string => {
  // Check URL parameter first
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const modeParam = urlParams.get('mode');
    if (modeParam && presets[modeParam]) {
      return modeParam;
    }
  }

  // Fall back to environment variable
  const envMode = import.meta.env.VITE_APP_MODE;
  if (envMode && presets[envMode]) {
    return envMode;
  }

  // Default to dating
  return 'dating';
};

export const appMode = getAppMode();
export const appConfig: AppConfig = getConfig(appMode);

export { presets, getConfig };
